import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import '../../../css/order.scss';
import { useTitle } from '../../../contexts/title';
import { useEffect } from 'react';
import {
	CFIInformationPanel,
	CustomerInformationPanel,
	ExitButton,
	SendReminderButton,
	StoreInformation,
	WorkOrderDatesPanel,
	WorkOrderDescriptionPanel,
	WorkOrderFilesButton,
	WorkOrderInformationPanel,
	WorkOrderNotes,
	WorkOrderPage
} from '../../../features/dealer/work-order';

export default function WorkOrderDetailsPage() {

	const pageTitle = useTitle();

	useEffect(() => {
		pageTitle.setTitle('Work Order Details');
	}, [pageTitle])

	return (

		<WorkOrderPage>

			<Toolbar className='button-toolbar'>
				<ToolbarItem location={'before'}>
					<StoreInformation />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<SendReminderButton />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<WorkOrderFilesButton />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<ExitButton />
				</ToolbarItem>
			</Toolbar>
			<Box>
				<Item ratio={1}>
					<WorkOrderInformationPanel />
				</Item>
				<Item ratio={1}>
					<CustomerInformationPanel />
				</Item>
				<Item ratio={1}>
					<CFIInformationPanel />
				</Item>
				<Item ratio={1}>
					<WorkOrderDatesPanel />
				</Item>
			</Box>

			<WorkOrderDescriptionPanel />

			<WorkOrderNotes />

		</WorkOrderPage>
	)
}
